<template>
    <va-edit-layout>
        <RetrochargeEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></RetrochargeEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
